import {
  DuviSharedAdminButton as Button,
  DuviSharedAdminIcon as Icon,
  DuviSharedAdminTestIds,
} from "@duvi-agency/ui";
import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminUserManagement } from "./use-duvi-core-admin-user-management";
import { DuviCoreAdminUserManagementView } from "./duvi-core-admin-user-management-view";

export function DuviCoreAdminUserManagement() {
  const state = useDuviCoreAdminUserManagement();

  return (
    <DuviCoreAdminAppShell
      title="User management"
      subtitle="Platform admin accounts"
      breadcrumbs={["Platform", "Users"]}
      activeMenuItem="Users"
      headerActions={
        <Button
          leftIcon={<Icon name="plus" size={15} />}
          onClick={state.openInvite}
          data-testid={DuviSharedAdminTestIds.userInviteButton}
        >
          Invite user
        </Button>
      }
    >
      <DuviCoreAdminUserManagementView {...state} />
    </DuviCoreAdminAppShell>
  );
}
